export default __webpack_public_path__ + "static/media/Info.8365af72.svg";